import React from "react"
import { Routes, Route, Navigate, useLocation } from "react-router-dom"
import "./AppLayout.css"
import Sidebar from "./SideMenu.js"
import TopMenu from "./TopMenu.js"
import SiteFooter from "./SiteFooter.js"
import ProtectedRoute from "./ProtectedRoute.js"
import HomePage from "../pages/HomePage.js"
import AboutPage from "../pages/AboutPage.js"
import WhoWeArePage from "../pages/WhoWeArePage.js"
import WhoWeServePage from "../pages/WhoWeServePage.js"
import CoveragePage from "../pages/CoveragePage.js"
import ContactPage from "../pages/ContactPage.js"
import FaqPage from "../pages/FaqPage.js"
import DisclaimerPage from "../pages/DisclaimerPage.js"
import MapPage from "../pages/MapPage.js"
import ChartsPage from "../pages/ChartsPage.js"
import ProfilePage from "../pages/ProfilePage.js"
import ReportsPage from "../pages/ReportsPage.js"
import UsersManagementPage from "../pages/UsersManagementPage.js"
import { useAuth } from "../hooks/useAuth"

// Routes that belong to the app (as opposed to the marketing site) —
// these are the only ones that get the Sidebar alongside them.
const isDashboardPath = (pathname) =>
  pathname === "/map" ||
  pathname.startsWith("/country/") ||
  pathname === "/profile" ||
  pathname === "/reports" ||
  pathname.startsWith("/admin")

const AppLayout = ({ compareMode, setCompareMode, compareCountries, setCompareCountries }) => {
  const { user } = useAuth()
  const location = useLocation()
  const showSidebar = isDashboardPath(location.pathname)

  return (
    <div className="app-layout">
      <TopMenu />

      <div className={`app-layout-body${showSidebar ? " has-sidebar" : ""}`}>
        {showSidebar && (
          <Sidebar
            compareMode={compareMode}
            setCompareMode={setCompareMode}
            compareCountries={compareCountries}
            setCompareCountries={setCompareCountries}
          />
        )}

        <main className="app-layout-main">
          <Routes>
            {/* Public marketing pages */}
            <Route path="/home" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/who-we-are" element={<WhoWeArePage />} />
            <Route path="/who-we-serve" element={<WhoWeServePage />} />
            <Route path="/coverage" element={<CoveragePage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/faq" element={<FaqPage />} />
            <Route path="/disclaimer" element={<DisclaimerPage />} />

            {/* App pages (gated) */}
            <Route path="/" element={<Navigate to="/home" replace />} />
            <Route path="/map" element={<ProtectedRoute><MapPage /></ProtectedRoute>} />
            <Route
              path="/country/:code"
              element={
                <ProtectedRoute>
                  <ChartsPage compareMode={compareMode} compareCountries={compareCountries} />
                </ProtectedRoute>
              }
            />
            <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
            <Route path="/reports" element={<ProtectedRoute><ReportsPage /></ProtectedRoute>} />
            <Route
              path="/admin/users"
              element={
                <ProtectedRoute>
                  {user?.role === "admin" ? <UsersManagementPage /> : <Navigate to="/map" replace />}
                </ProtectedRoute>
              }
            />
          </Routes>

          <SiteFooter />
        </main>
      </div>
    </div>
  )
}

export default AppLayout
